import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import "../../styles/globals.css";
import "./AccountRegistDonePage.css";
import { AppContext } from "../../contexts/AppContext";

function AccountRegistDonePage() {
  useEffect(() => {}, []);
  const { globalMedicalInstitutionId } = useContext(AppContext);
  const navigate = useNavigate();
  const handleLoginClick = () => {
    // ログイン画面に遷移
    navigate("/mypage/account-login");
  };

  const handleGoToReservationMenu = () => {
    // 予約メニュー選択画面に遷移
    navigate(
      `/reservation-menu#medicalInstitutionId=${globalMedicalInstitutionId}`
    );
  };

  return (
    <div className="account-regist-done">
      <div className="main-area">
        <div className="done-message-area">
          <CheckCircleOutlined className="done-message-icon" />
          <div className="done-message-label">
            アカウント登録完了いたしました
          </div>
        </div>

        <div className="done-message-detail">
          次回以降のご予約の際はログインして予約することができ、
          <br />
          今回入力した氏名・住所などの情報を使って予約することができます。
        </div>

        <GeneralButton
          buttonLabel={"ログイン"}
          type={"secondary-blue"}
          onClick={() => handleLoginClick()}
        />
        <div className="back-to-reservation-menu">
          <GeneralButton
            buttonLabel={"予約メニュー選択に戻る"}
            type={"link-blue"}
            onClick={() => handleGoToReservationMenu()}
          />
        </div>
      </div>
    </div>
  );
}

export default AccountRegistDonePage;
